import { useStoredState } from "@/hooks/useStoredState";
import { ToolShell } from "@/components/tools/ToolShell";
import { AutoTextarea, Pills, TextField } from "@/components/tools/fields";

const TERMS = ["Autumn", "Spring", "Summer"].map((t) => ({ v: t, label: t }));
const NUMBERS = [
  { k: "register", label: "SEND Register total" },
  { k: "ehcp", label: "EHCP total" },
  { k: "referrals", label: "New referrals" },
  { k: "attendance", label: "Attendance concerns" },
  { k: "absence", label: "Persistent absence" },
  { k: "exclusions", label: "Exclusions" },
];
const TEXT = [
  { k: "well", label: "What has gone well?" },
  { k: "action", label: "Areas requiring action" },
  { k: "priorities", label: "Priorities next term" },
];

export const TermlyReview = () => {
  const [data, setData, reset] = useStoredState("termly-review", {});
  const set = (k) => (v) => setData((d) => ({ ...d, [k]: v }));
  return (
    <ToolShell id="termly-review" onReset={reset}>
      <Pills legend="Term" hideLegend={false} name="tr-term" options={TERMS} value={data.term} onChange={set("term")} testid="tr-term" />
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {NUMBERS.map((f) => (
          <TextField key={f.k} id={`tr-${f.k}`} label={f.label} type="number" inputMode="numeric" min="0" value={data[f.k]} onChange={set(f.k)} testid={`tr-${f.k}`} />
        ))}
      </div>
      <div className="mt-6 grid gap-4 md:grid-cols-3">
        {TEXT.map((f) => <AutoTextarea key={f.k} id={`tr-${f.k}`} label={f.label} rows={4} value={data[f.k]} onChange={set(f.k)} testid={`tr-${f.k}`} />)}
      </div>
      <div className="mt-6 max-w-xs">
        <TextField id="tr-review" label="Review date" type="date" value={data.review} onChange={set("review")} testid="tr-review" />
      </div>
    </ToolShell>
  );
};
